module.exports = __webpack_public_path__ + "static/21import-94c32515a3f51cfa5ebaa4617f60673f.png";